import React, { useState } from 'react';
import { Alert, Box, Button, Stack, Typography } from '@mui/material';

import { useSubscription } from '../../../hooks/useSubscription';
import { useTrialStatus } from '../../../hooks/useTrialStatus';
import DialogHeader from '@shared/ui/dialog/DialogHeader';
import { UpdateSubscriptionDialog } from '../plans/UpdateSubscriptionDialog';
import { ShopifySubscriptionSection } from './ShopifySubscriptionSection';
import { StripeSubscriptionSection } from './StripeSubscriptionSection';
import { Paper } from '@shared/ui';

export const CompanySubscriptionCard: React.FC = () => {
  const { currentSubscription } = useSubscription();
  const { isTrialActive, isTrialEndingSoon, getTrialStatusText } = useTrialStatus();
  const [manageDialogOpen, setManageDialogOpen] = useState(false);

  const isShopifyBilling = currentSubscription?.provider === 'shopify';

  return (
    <>
      <Paper>
        <DialogHeader>
          <Typography variant="h6">Subscription</Typography>
        </DialogHeader>

        {!currentSubscription ? (
          <Box sx={{ p: 3 }}>
            <Button variant="outlined" onClick={() => setManageDialogOpen(true)}>
              Get access to JustStock
            </Button>
          </Box>
        ) : (
          <Stack spacing={2} sx={{ p: isShopifyBilling ? 4 : 3 }}>

            {isShopifyBilling ? (
              <ShopifySubscriptionSection
                subscription={currentSubscription}
                onChangePlan={() => setManageDialogOpen(true)}
              />
            ) : (
              <StripeSubscriptionSection
                subscription={currentSubscription}
                onChangePlan={() => setManageDialogOpen(true)}
              />
            )}

            {isTrialActive && (
              <Alert severity={isTrialEndingSoon() ? 'warning' : 'info'}>
                {getTrialStatusText()}
              </Alert>
            )}


            {currentSubscription.cancelAtPeriodEnd && (
              <Alert severity="warning">
                Subscription will be canceled at the end of the current period.
              </Alert>
            )}
          </Stack>
        )}
      </Paper>

      <UpdateSubscriptionDialog
        open={manageDialogOpen}
        onClose={() => setManageDialogOpen(false)}
        onSuccess={() => setManageDialogOpen(false)}
      />
    </>
  );
};
